import { render, staticRenderFns } from "./MitActionsNewPerson.vue?vue&type=template&id=b1e837da&scoped=true"
import script from "./MitActionsNewPerson.vue?vue&type=script&lang=js"
export * from "./MitActionsNewPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e837da",
  null
  
)

export default component.exports